<ng-container *transloco="let t;">
  <app-list-view [title]="title" [messages]="messages" [loading]="loading">

    <div buttons>
      <div class="p-grid">
        <div class="p-col-6 p-d-flex p-jc-end p-ai-center">
          <ng-container *ngIf="loading !== true && mode === 'orders'">
            <div>
              {{ t('order_list.show_finished') }}
            </div>
            <div>
              <p-inputSwitch [(ngModel)]="showFinished" class="p-ml-2" tabindex="0" (onChange)="showFinishedChanged()"></p-inputSwitch>
            </div>
          </ng-container>
        </div>
        <div class="p-col-4 p-d-flex p-jc-end p-ai-center">
          <ng-container *ngIf="loading !== true">
            <div>
              {{ t('common.labels.show_details') }}
            </div>
            <div>
              <p-inputSwitch [(ngModel)]="showDetails" class="p-ml-2" tabindex="0" (onChange)="saveListState()"></p-inputSwitch>
            </div>
          </ng-container>
        </div>
        <div class="p-col-2 p-text-right">
          <button withRight="admin.planning-orders.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
        </div>
      </div>
    </div>

    <div table>
      <p-table
        [value]="orders"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        [stateKey]="mode + '-list'"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="ordernumber">{{ t('common.labels.id') }}
                  <p-sortIcon field="ordernumber"></p-sortIcon>
              </th>
              <th *ngIf="mode === 'clearings'"></th>
              <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="orderer_name">{{ t('common.labels.orderer') }}
                  <p-sortIcon field="orderer_name"></p-sortIcon>
              </th>
              <th pSortableColumn="dispatcher_name">{{ t('common.labels.dispatcher') }}
                  <p-sortIcon field="dispatcher_name"></p-sortIcon>
              </th>
              <th pSortableColumn="hiringmanager_name">{{ t('common.labels.hiringmanager') }}
                  <p-sortIcon field="hiringmanager_name"></p-sortIcon>
              </th>

              <ng-container *ngIf="showDetails === false">
                <th pSortableColumn="moderator_name">{{ t('common.labels.moderator_firstletter') }}
                    <p-sortIcon field="moderator_name"></p-sortIcon>
                </th>
                <th>{{ t('common.labels.observer_firstletter') }}</th>
                <th>{{ t('common.labels.candidate_firstletter') }}</th>
                <th>{{ t('common.labels.room_firstletter') }}</th>
              </ng-container>
              <ng-container *ngIf="showDetails === true">
                <th pSortableColumn="moderator_name">{{ t('common.labels.moderator') }}
                    <p-sortIcon field="moderator_name"></p-sortIcon>
                </th>
                <th>{{ t('common.labels.observers') }}</th>
                <th>{{ t('common.labels.candidate') }}</th>
                <th>{{ t('common.labels.room') }}</th>
              </ng-container>

              <th pSortableColumn="location">{{ t('common.labels.location') }}
                  <p-sortIcon field="location"></p-sortIcon>
              </th>
              <th pSortableColumn="status">{{ t('common.labels.status') }}
                  <p-sortIcon field="status"></p-sortIcon>
              </th>
              <th pSortableColumn="start_time">{{ t('common.labels.execution') }}
                  <p-sortIcon field="start_time"></p-sortIcon>
              </th>
            </tr>
            <tr class="filter">
              <th>
                <p-columnFilter type="text" field="ordernumber" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th *ngIf="mode === 'clearings'"></th>
              <th>
                <p-columnFilter type="text" field="name" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="orderer_name" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="dispatcher_name" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="hiringmanager_name" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <ng-container *ngIf="showDetails === false">
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </ng-container>
              <ng-container *ngIf="showDetails === true">
                <th>
                  <p-columnFilter type="text" field="moderator_name" [matchMode]="'contains'"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter type="text" field="observer_names" [matchMode]="'contains'"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter type="text" field="candidate_names" [matchMode]="'contains'"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter type="text" field="room_name" [matchMode]="'contains'"></p-columnFilter>
                </th>
              </ng-container>
              <th>
                <p-columnFilter type="text" field="locationName" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="translatedStatusName" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="date" field="start_time_as_date" [showMatchModes]="true" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-calendar #calendar [ngModel]="value" (onSelect)="filter(calendar.value)" (onInput)="setup(calendar.value, 'start_time_as_date')" dateFormat="dd.mm.yy"></p-calendar>
                  </ng-template>
                </p-columnFilter>
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-order>
            <tr (click)="onOpen(order)" (keyup.enter)="onOpen(order)" hoverOnRight="admin.planning-orders.show" tabindex="0">
              <td>{{ order.ordernumber }}</td>
              <td *ngIf="mode === 'clearings'">
                <i *ngIf="order.clearing_info !== null" (click)="showNodatesInfo($event, order)" class="pi pi-exclamation-circle error"></i>
              </td>
              <td><span role="link">{{ order.name }}</span></td>
              <td>{{ order.orderer_name }}</td>
              <td>{{ order.dispatcher_name }}</td>
              <td>{{ order.hiringmanager_name }}</td>

              <ng-container *ngIf="showDetails === false">
                <td><i *ngIf="order.moderator" class="pi pi-check"></i></td>
                <td><i *ngIf="order.observers.length > 0" class="pi pi-check"></i></td>
                <td><i *ngIf="order.hasCandidate()" class="pi pi-check"></i></td>
                <td><i *ngIf="order.hasRooms()" class="pi pi-check"></i></td>
              </ng-container>
              <ng-container *ngIf="showDetails === true">
                <td>{{ order.moderator_name }}</td>
                <td>
                  <ul>
                    <li *ngFor="let observer of order.observers">{{ observer.fullname }}</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li *ngFor="let candidate of order.candidates">{{ candidate.fullname | anonymizedCandidate }}</li>
                  </ul>
                </td>
                <td>{{ order.getMainRoomName() }}</td>
              </ng-container>

              <td>
                <span *ngIf="order.virtual !== 1">{{ order.locationName }}</span>
                <span *ngIf="order.virtual === 1">{{ t('common.labels.virtual') }}</span>
              </td>
              <td>{{ order.translatedStatusName }}</td>
              <td>{{ order.start_time_as_date | amDateFormat: 'DD.MM.YYYY' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="12">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>

    </div>

  </app-list-view>
</ng-container>
